import React, { ReactNode } from 'react';
import { ReadWritePermissions } from '../../../../Auth/components/PermissionGate';
import { ValidationResult } from '../../../../util/validation/interfaces';
import { ReferencedPersonNameDTO } from '../../../../api/core';
import { LabelledDropdown } from '../../../components/form/LabelledDropdown';
import { SelectItem } from 'primereact/selectitem';

interface LabelledPersonNameSuggesterProps {
  id: string;
  autoFocus?: boolean;
  value: number;
  permissions: ReadWritePermissions;
  validation: ValidationResult;
  onChange: (id: number) => void;
  disabled: boolean;
  label: string;
  options: ReferencedPersonNameDTO[];
  wrapperClassName?: string;
  onShow?: () => void;
}

export const LinkedPersonName = (props: LabelledPersonNameSuggesterProps): ReactNode => {
  return (
    <LabelledDropdown
      id={props.id}
      wrapperClassName={props.wrapperClassName}
      autoFocus={props.autoFocus}
      value={props.value}
      disabled={props.disabled}
      permissions={props.permissions}
      validation={props.validation}
      onChange={(id: number): void => props.onChange(id)}
      onShow={props.onShow}
      label={props.label}
      options={(props.options || []).map((option: ReferencedPersonNameDTO): SelectItem => ({
        label: `${option.givenname} ${option.surname}`,
        value: option.id,
      }))}
    >
    </LabelledDropdown>
  );
};
